import React from 'react';
import { Lock, Wallet, Sparkles } from 'lucide-react';

/**
 * Overlay shown on the vault panel while no wallet (real or demo) is
 * connected. Exposes both the real wallet modal and the 'Try demo mode'
 * shortcut used by judges/automated testing.
 */
export default function VaultDisconnectedOverlay({ onConnect, onDemo }) {
  return (
    <div
      className="absolute inset-0 z-20 flex items-center justify-center p-6"
      data-testid="vault-disconnected-overlay"
    >
      <div className="absolute inset-0 backdrop-blur-md bg-[#041411]/40" />
      <div className="relative text-center max-w-sm">
        <div className="mx-auto w-14 h-14 rounded-2xl glass flex items-center justify-center text-palm-lime mb-5">
          <Lock size={22} strokeWidth={1.6} />
        </div>
        <h3 className="font-display font-bold text-2xl tracking-tight">Vault locked</h3>
        <p className="mt-2 text-white/70 leading-relaxed">
          Connect your Phantom or Solflare wallet to deposit PUSD, mint yPUSD, and start
          earning yield.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
          <button
            type="button"
            onClick={onConnect}
            className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-xl bg-palm-lime text-palm-surface font-bold shadow-lime hover:bg-palm-limeHover transition-all"
            data-testid="vault-connect-button"
          >
            <Wallet size={16} strokeWidth={2} />
            Connect Wallet
          </button>
          <button
            type="button"
            onClick={onDemo}
            className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-xl glass text-white/90 hover:border-palm-mint/40 transition-all"
            data-testid="vault-demo-button"
          >
            <Sparkles size={14} strokeWidth={1.8} className="text-palm-mint" />
            Try demo mode
          </button>
        </div>
      </div>
    </div>
  );
}
